import { faExclamationTriangle, faLuggageCart } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AvailableFareSegmentModel } from "WebApiClient";

interface RenderBaggageProps {
    segments: AvailableFareSegmentModel[];
}

export const RenderBaggage: React.FC<RenderBaggageProps> = ({ segments }) => (
    <>
        {segments.map((segment, index) => (
            <span key={`baggage-${index}`}>
                <span>
                    {!segment.hasFreeBaggage ? (
                        <>
                            <FontAwesomeIcon
                                style={{ opacity: 0.3 }}
                                title="No free baggage"
                                icon={faLuggageCart}
                            />
                            <FontAwesomeIcon
                                style={{ color: "red" }}
                                icon={faExclamationTriangle}
                                transform="shrink-7 down-4 left-9"
                            />
                        </>
                    ) : (
                        segment.freeBaggageAllowance
                    )}
                </span>
                <br />
            </span>
        ))}
    </>
);
